import { useSession, roleLabel } from "@vixio/data";
import { EmptyState, PageHeader, Panel, VixioSymbol, cx } from "@vixio/ui";
import { widgetGroupsFor } from "../shell/registry";
import { useActiveModules } from "../shell/useActiveModules";

const TZ = "America/Bahia";
const longDate = new Intl.DateTimeFormat("pt-BR", { weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: TZ });

function greeting(now = new Date()): string {
  const h = Number(new Intl.DateTimeFormat("pt-BR", { hour: "numeric", hour12: false, timeZone: TZ }).format(now));
  return h < 12 ? "Bom dia" : h < 18 ? "Boa tarde" : "Boa noite";
}

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export function HomePage() {
  const session = useSession();
  const mods = useActiveModules();
  const groups = widgetGroupsFor(mods, session.org);
  const org = session.org!;
  return (
    <div className="vx-content os-home">
      {/* Abertura do Início: faixa com a aurora da marca e o símbolo ao fundo (decorativos). */}
      <div className="os-hero">
        <span className="os-hero__art" aria-hidden="true">
          <VixioSymbol size={168} />
        </span>
        <PageHeader
          eyebrow={capitalize(longDate.format(new Date()))}
          title="Início"
          description={`${greeting()}. O resumo de ${org.name} hoje, com o seu papel de ${roleLabel(org.role).toLowerCase()}.`}
        />
      </div>
      {groups.length === 0 ? (
        <Panel>
          <EmptyState title="Nada para mostrar aqui ainda">
            Os módulos ligados nesta organização trazem seus painéis para o Início. Com o seu papel, nenhum painel está
            disponível.
          </EmptyState>
        </Panel>
      ) : (
        <>
          {groups.length > 2 ? (
            <nav className="os-home__jump" aria-label="Áreas do resumo">
              {groups.map((g) => (
                <a key={g.domain} href={`#area-${g.domain}`}>
                  {g.label}
                  <span className="num">{g.widgets.length}</span>
                </a>
              ))}
            </nav>
          ) : null}
          {groups.map((g) => (
            <section key={g.domain} className="os-home__group" id={`area-${g.domain}`} aria-labelledby={`area-${g.domain}-t`}>
              <h2 className="os-home__group-title" id={`area-${g.domain}-t`}>
                {g.label}
              </h2>
              <div className="os-widgets">
                {g.widgets.map((w) => {
                  const W = w.element;
                  return (
                    <Panel key={w.key} title={w.title} level={3} id={`w-${w.key}`} className={cx("os-widget", `os-span-${w.span ?? 1}`)}>
                      <W />
                    </Panel>
                  );
                })}
              </div>
            </section>
          ))}
        </>
      )}
    </div>
  );
}
